import { useQuery } from 'react-query';
import { useBlockData } from '../BlockData';
import { BlockQueryKeys } from '../BlockQueryKeys';
export function useBlockImageUrl(imageId, targetSize) {
    const { getImageUrl } = useBlockData();
    return useQuery(BlockQueryKeys.image(imageId, targetSize), () => getImageUrl(imageId, targetSize), { cacheTime: Infinity, enabled: Boolean(imageId) });
}
